import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExcFileItemQuestionnaire} from './ExcFileItemQuestionnaire';
import {DynamicInputsInterface} from './DynamicInputs.interface';
import {ExgModalService} from 'exc-controls-v2';
import {PdfViewerComponent} from 'ng2-pdf-viewer';
import Viewer from 'viewerjs';

@Component({
  selector: 'app-modal-attachment-viewer',
  templateUrl: './modal-attachment-viewer.component.html',
  styles: []
})
export class ModalAttachmentViewerComponent extends ExcTranslation implements OnInit {

  @ViewChild('imgHost') imgHost: ElementRef<HTMLImageElement> | undefined;
  @ViewChild('vidHost') vidHost: ElementRef<HTMLVideoElement> | undefined;
  @ViewChild(PdfViewerComponent) pdfViewerComponent: PdfViewerComponent | undefined;
  excRestServiceCore = ExcCoreModule.Services().ExcRest;

  @Input() data: any;

  resourceIdentifier = 'ID';
  entityName = '';
  extensionName = '';
  ID: any;
  qverID: any;
  isDisabled: any;
  uuid = ExcCoreModule.Guid.NewGuid();

  _uploads: ExcFileItemQuestionnaire[] = [];
  get uploads(): ExcFileItemQuestionnaire[] {
    return this._uploads;
  }

  set uploads(value: ExcFileItemQuestionnaire[]) {
    this._uploads = value;
  }

  _galleryData: any[] = [];
  set galleryData(value: any[]) {
    this._galleryData = value;
  }

  get galleryData(): any[] {
    return this._galleryData;
  }

  dynamicInputs: DynamicInputsInterface[] = [
    {
      apiValue: 'Label',
      displayValue: 'Name'
    },
    {
      apiValue: 'Description',
      displayValue: 'Beschreibung'
    }
  ];
  currentIndex = -1;

  get galleryDataCount(): number {
    return this.galleryData.length;
  }

  get currentItem(): any {
    return this.galleryData[this.currentIndex];
  }

  _resourcesData: { [key: string]: any } = {};

  get currentResource(): any {
    if (this.currentItem) {
      return this._resourcesData[this.currentItem[this.resourceIdentifier]];
    } else {
      return undefined;
    }
  }

  set currentResource(value: any) {
    this._resourcesData[this.currentItem[this.resourceIdentifier]] = value;
  }

  viewer: Viewer | undefined;
  isLoading = false;
  supportedMIMEs: string[] = [
    'image/.*',
    'video/.*',
    'application/pdf'
  ];
  notSupportedMIME = false;
  throttleId: any;
  throttle = 80;

  constructor(public modalService: ExgModalService) {
    super();
  }

  ngOnInit(): void {
    const _self = this;
    this.ID = this.data.ID;
    this.qverID = this.data.qverID;
    this.isDisabled = this.data.isDisabled;
    this.entityName = this.data.entityName;
    this.extensionName = this.data.extensionName;
    if (this.data.index) {
      _self.loadAttachments(this.data.index);
    } else {
      _self.loadAttachments(0);
    }
  }

  loadAttachments(index: number): void {
    const _self = this;
    const url = _self.excRestServiceCore.computeUrl(this.entityName + this.extensionName + 'R_List', {
      FKID: _self.ID,
      qverID: _self.qverID
    });
    _self.excRestServiceCore.sget(url, _self.uuid, {})
      .subscribe((data: { data: any[]; }) => {
        _self.uploads = [];
        if (data.data) {
          data.data
            .forEach(item => _self.uploads.push(ExcFileItemQuestionnaire.fromApiResponse(item, _self.dynamicInputs)));
          _self.galleryData = _self.uploads.map(upload => ExcFileItemQuestionnaire.toApiResponse(upload, _self.dynamicInputs));
          if (_self.galleryDataCount > 0) {
            _self.currentIndex = index;
            setTimeout(() => _self.showIndex(_self.currentIndex), 100);
          }
        }
      });
  }

  fileUpload(fileData: any[]): void {
    const _self = this;
    const formData = new FormData();
    fileData.forEach(fileItem => formData.append('file[]', fileItem.asBlob, fileItem.fullName));
    // console.log(fileData, formData);
    _self.excRestServiceCore.post(_self.excRestServiceCore.computeUrl(this.entityName + this.extensionName + 'C', {
        FKID: _self.ID,
        qverID: _self.qverID
      }),
      formData, {})
      .subscribe(() => {
        _self.loadAttachments(0);
      });
  }

  fileDelete(fileData: any): void {
    const _self = this;
    const url = this.excRestServiceCore.computeUrl(this.entityName + this.extensionName + 'D', {FKID: _self.ID});
    this.excRestServiceCore.delete(url, fileData, {}).subscribe((response: { success: any; }) => {
      if (response.success) {
        if (_self.currentIndex > 0) {
          _self.currentIndex = _self.currentIndex - 1;
        }
        if (_self.galleryDataCount === 1) {
          _self.modalService.action(0);
        } else {
          _self.loadAttachments(_self.currentIndex);
        }
      }
    });
  }

  initImageViewer(): void {
    this.destroyImageViewer();
    if (this.imgHost) {
      this.viewer = new Viewer(this.imgHost.nativeElement, {
        // inheritedAttributes: [],
        inline: true,
        title: false,
        navbar: false,
        toolbar: {
          zoomIn: true,
          zoomOut: true,
          oneToOne: true,
          reset: true,
          prev: false,
          play: false,
          next: false,
          rotateLeft: true,
          rotateRight: true,
          flipHorizontal: true,
          flipVertical: true
        },
        button: false,
        fullscreen: true,
        transition: false
      });
    }
  }

  destroyImageViewer(): void {
    if (this.viewer) {
      this.viewer.destroy();
      this.viewer = undefined;
    }
  }

  showIndex(currentIndex: number): void {
    // -- set always to false to avoid rendering of the wrong mime hint
    this.notSupportedMIME = false;

    if (this.throttleId) {
      clearTimeout(this.throttleId);
    }

    this.throttleId = setTimeout(async () => {
      this.startLoadingAnimation();

      // -- check if this data is supported
      if (!this.isMIMESupported()) {
        this.notSupportedMIME = true;
        this.stopLoadingAnimation();
      } else {
        this.notSupportedMIME = false;
      }
      // -- load resource
      if (!this.currentResource) {
        this.currentResource = await this.getCurrentResourceBinary();
      }

      // reinit image viewer if currentResource is an image
      if (this.isCurrentItemImage()) {
        setTimeout(() => this.initImageViewer(), 200);
      } else {
        this.destroyImageViewer();
      }

      // start video player
      if (this.isCurrentItemVideo() && this.vidHost) {
        this.vidHost.nativeElement.load();
      }

      this.stopLoadingAnimation();
    }, this.throttle);
  }
  async getCurrentResourceBinary(): Promise<any> {
    // for video and pdf stream url request
    if (this.isCurrentItemVideo() || this.isCurrentItemPDF()) {
      return this.excRestServiceCore.computeUrl(this.entityName + this.extensionName + 'R', {ID: this.currentItem.ID, video: true});
    }

    const url = this.excRestServiceCore.computeUrl(this.entityName + this.extensionName + 'R', {ID: this.currentItem.ID});
    const response = await this.excRestServiceCore.sget(url, null, {}).toPromise();

    // for image request
    if (this.isCurrentItemImage()) {
      return 'data:' + this.currentItem.MIME + ';base64,' + response.data.FileStream;
    }
    return response;
  }

  showPrev(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.showIndex(this.currentIndex);
    }
  }

  showNext(): void {
    if (this.currentIndex < this.galleryDataCount - 1) {
      this.currentIndex++;
      this.showIndex(this.currentIndex);
    }
  }

  isMIMESupported(): boolean {
    return this.supportedMIMEs.some(mime => new RegExp(mime).test(this.currentItem.MIME));
  }

  isCurrentItemVideo(): boolean {
    return this.currentItem.MIME.indexOf('video/') > -1;
  }

  isCurrentItemImage(): boolean {
    return this.currentItem.MIME.indexOf('image/') > -1;
  }

  isCurrentItemPDF(): boolean {
    return this.currentItem.MIME.indexOf('application/pdf') > -1;
  }
  async downloadCurrentItem(): Promise<void> {
    const queryParams = {
      ID: this.currentItem.ID,
      export: true,
    } as any;
    // for video and pdf stream url request
    if (this.currentItem.MIME.indexOf('video/') > -1 || this.currentItem.MIME.indexOf('application/pdf') > -1) {
      queryParams.video = true;
    }
    const url = this.excRestServiceCore.computeUrl(this.entityName + this.extensionName + 'R', queryParams);
    const response = await this.excRestServiceCore.sget(url, null, {export: true}).toPromise();
  }

  private startLoadingAnimation(): void {
    this.isLoading = true;
  }

  private stopLoadingAnimation(): void {
    this.isLoading = false;
  }

}
